import { SupportGuardService } from './support-guard.service';
import { LocalStorageService } from './local-storage.service';
import { AccountsService } from './accounts.service';
import { NewsService } from './news.service';
import { NewsGuardService } from './news-guard.service';

export const services = [
  SupportGuardService,
  LocalStorageService,
  AccountsService,
  NewsService,
  NewsGuardService
];
